import { SvgIcon, useTheme } from "@mui/material";

const AcceptIcon = ({ color }) => {

    const theme = useTheme();

    return (
        <SvgIcon>
            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                <g clipPath="url(#clip0_219_13052)">
                    <path d="M10.9059 19.9391L3.48682 12.52L4.65244 11.3544L10.9059 17.607L22.1054 6.40833L23.2711 7.57396L10.9059 19.9391Z" fill={color || theme.palette.primary.main} />
                </g>
                <defs>
                    <clipPath id="clip0_219_13052">
                        <rect width="26.379" height="26.379" fill="white" transform="translate(0.189453 0.154861)" />
                    </clipPath>
                </defs>
            </svg>
        </SvgIcon>
    );

};

export default AcceptIcon;